if (!global.WebSocket) {
  throw new Error(
    'Attempt to use WebSocket in unsupported environment.'
  );
}

export default class WSClient {
  constructor(opts = {}) {
    this._url = opts.url;
    this._retries = Number.isInteger(opts.retries) ? opts.retries : 5;
    this._retryTimeout = opts.retryTimeout || 2000;
    this._socket = null;
    this._queue = [];
    this._isConnected = false;
    this._listeners = [];
  }

  connect() {
    if (this._socket) return;

    this._socket = new WebSocket(this._url);
    this._socket.onopen = this._onOpen.bind(this);
    this._socket.onclose = this._onClose.bind(this);
    this._socket.onerror = this._onError.bind(this);
    this._socket.onmessage = this._onEvent.bind(this);
  }

  disconnect() {
    if (!this._socket) return;

    this._socket = null;
    this._onStatusChanged = null;
  }

  send(message) {
    const jsonMsg = JSON.stringify(message);
    if (this._socket && this._socket.readyState === WebSocket.OPEN) {
      this._socket.send(jsonMsg);
    } else {
      this._queue.push(jsonMsg);
    }
  }

  onMessage(cb) {
    this._listeners.push(cb);

    return () => {
      this._listeners = this._listeners.filter(listener => listener !== cb);
    };
  }

  onStatusChanged(cb) {
    this._onStatusChanged = cb;
  }

  _onOpen() {
    // send queued messages
    this._setConnected(true);
    while (this._queue.length > 0) {
      const jsonMsg = this._queue.shift();
      this._socket.send(jsonMsg);
    }
  }

  _onError(err) {
    console.log('WSError: ', err.message);
    if (this._socket.readyState === 'CLOSING'
      || this._socket.readyState === 'CLOSED') {
      this._setConnected(false);
    }
  }

  _onClose() {
    this._setConnected(false);
    this.disconnect();

    if (this._retries > 0) {
      this._retries--;
      setTimeout(() => {
        this.connect();
      }, this._retryTimeout)
    }
  }

  _onEvent(evt) {
    if (evt && evt.data) {
      const msg = JSON.parse(evt.data)
      this._listeners.forEach(listener => listener(msg));
    }
  }

  _setConnected(value) {
    this._isConnected = value;
    if (typeof this._onStatusChanged === 'function') {
      this._onStatusChanged(this._isConnected);
    }
  }
}